import { render, staticRenderFns } from "./SupervisorEditForm.vue?vue&type=template&id=ba59c254&scoped=true&"
import script from "./SupervisorEditForm.vue?vue&type=script&lang=js&"
export * from "./SupervisorEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba59c254",
  null
  
)

export default component.exports